<template>

	<app-boards board-key="success_examples"></app-boards>

</template>

<script>
import AppBoards from "@/components/boards/appBoards";
export default {
	name: "success_examples",
	components: {AppBoards}
}
</script>

<style scoped>

</style>